import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

const HeaderBanner = props => (
  <div className="py-4 mx-0" style={{ background: props.header_color }}>
    <div className=" d-flex flex-column-reverse flex-md-row flex-lg-row">
      <Container className="overflow-hidden text-right">
        <Row className="reverse-mobile m-auto">
          <Col md={8} sm={12} className="align-self-center">
            <h3 className="mb-3" style={{ fontSize: props.headerSize}}>{props.title}</h3>
            <p className="text-justify line-height-2">{props.body}</p>
            {props.action ? (
              <div
                className="justify-content-center"
                style={{ padding: "20px 0" }}>
                <Button
                  bsPrefix="header-banner-action"
                  href={props.action_href}>
                  {props.action}
                </Button>
              </div>
            ) : (
              ""
            )}
          </Col>
          <Col md={4} sm={12}>
            <div className="justify-content-center header-banner-image">
              <img
                alt="header"
                src={props.image}
                style={{ width: "100%", height: "100%", maxWidth: "250px" }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
);

export default HeaderBanner;
